import { useRecording } from '@/app/mutations/RecordingMutation/context';

export default function RecordingBadge() {
  const { isRecording } = useRecording();

  if (!isRecording) {
    return null;
  }

  return (
    <span className="flex shrink-0 items-center gap-2 rounded-full bg-black/50 px-3 py-1 text-xs text-white">
      <span className="RecordingCircle" />
      Recording
    </span>
  );
}
